import React, { useState } from 'react';
import axios from 'axios';

import ImageGrid from '../components/ImageGrid';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, TextField, Typography, Container, Box, styled} from '@mui/material';

import RefreshIcon from '@mui/icons-material/Refresh';
import Check from '@mui/icons-material/Check';
import TheatersIcon from '@mui/icons-material/Theaters';
import AdminProductView from '../components/AdminProductView';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import CloseIcon from '@mui/icons-material/Close';

import Sidebar from '../components/Sidebar';
import ImageGalleryWithCarusel from '../components/ImageGalleryWithCarusel';
import config from '../config';
import FurnitureViewer from '../components/FurnitureViewer';
import { ContentContainer, PageContainer } from '../components/ContentContainer';




const UploadCsvPage  = () => {

  const navigate = useNavigate();
    const [retailer, setRetailer] = useState('');
    const [board, setBoard] = useState('');
    const [file, setFile] = useState(null);


    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('retailer', retailer);
        formData.append('board', board);
        formData.append('file', file);

        try {
            const response = await axios.post(`${config.serverUrl}/retailer`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert('File uploaded successfully');
        } catch (error) {
            console.error('There was an error uploading the file!', error);
        }
    };

  return (
  <PageContainer>
      <Sidebar navigate={navigate} />
      <ContentContainer>
      <Container maxWidth="sm">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100vh"
            >
                <Typography variant="h4" gutterBottom>
                    CSV File Upload
                </Typography>
                <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                    <TextField
                        label="Retailer"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={retailer}
                        onChange={(e) => setRetailer(e.target.value)}
                        required
                    />
                    <TextField
                        label="Board"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={board}
                        onChange={(e) => setBoard(e.target.value)}
                        required
                    />
                    <Button
                        variant="contained"
                        component="label"
                        fullWidth
                        margin="normal"
                    >
                        Upload CSV File
                        <input
                            type="file"
                            hidden
                            onChange={handleFileChange}
                            required
                        />
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ marginTop: '20px' }}
                    >
                        Upload
                    </Button>
                </form>
            </Box>
        </Container>
      </ContentContainer>
    </PageContainer>
  );
};

export default UploadCsvPage;
